export default {
  boardMetadata: {
    tooltips: {
      nextTask: 'Задача станет доступной после завершения предыдущей',
      commonProgress: 'Прогресс прохождения плана адаптации',
      noPlans: 'Отсутствуют планы',
      deleteCards: 'Удалить все задачи в статусе «Готово»',
      roadmap: 'Задача из плана по самооценке',
      roadmap360: 'Задача из плана по оценке 360',
      meetingTask: 'Задача из встречи 1-on-1',
      manual: 'Задача добавлена вручную',
      notDeleteSectionTop: 'Задача в очевидных зонах роста. Удалить нельзя',
      notDeleteFixed: 'Задача в зафиксированном плане развития. Удалить нельзя',
      fixedRoadmap: 'Задача в зафиксированном плане развития',
      overdue: 'Срок выполнения истёк',
      reminder: 'Срок выполнения подходит к концу',
    },
    stepsCompleted: 'Выполнено</br> задач',
    stepsAvailable: 'Доступно после выполнения {step} шага',
    statuses: {
      study: 'Изучить',
      done: 'Готово',
      overdue: 'Просрочено',
      new: 'Новая',
      progress: 'В работе',
      completed: 'Завершена',
      expired: 'Просрочена',
    },
    noPlans: {
      user: 'У вас нет назначенных планов',
      supervisor: 'У сотрудника нет назначенных планов',
      bot: 'Чтобы точно не пропустить назначенный план, подключите {link} бота помощника',
    },
    successMessages: {
      completedTask: 'Задача успешно выполнена',
      completedPlan: 'План успешно пройден',
      deleteMaterial: 'Задача удалена из плана развития',
      deleteMeetingTask: 'Задача удалена из встречи',
      createTask: 'Задача успешно создана',
      changeTask: 'Задача успешно изменена',
    },
    errorMessages: {
      completedTask: 'Не удалось выполнить задачу',
      adaptations: 'Не удалось получить список адаптаций',
      changeStatus: 'Не удалось изменить статус задачи',
      deleteMaterial: 'Не удалось удалить задачу из плана развития',
      deleteMeetingTask: 'Не удалось удалить задачу из встречи',
      createTask: 'Не удалось создать задачу',
      changeTask: 'Не удалось изменить задачу',
      moveTask: 'Не удалось изменить статус задачи',
    },
    buttons: {
      complete: 'Завершить задачу',
      close: 'Закрыть',
      addTask: 'Добавить задачу',
      removeTask: 'Удалить задачу',
    },
    formLabels: {
      tags: 'Тэги',
      importance: 'Важность',
      period: 'Период',
      name: 'Название задачи',
      roadmap: 'План развития',
      skillId: 'Компетенция',
      deadline: 'Дедлайн',
      typeId: 'Тип материала',
    },
    confirmDeleteCard: {
      title: 'Удалить?',
      text: 'Задача будет удалена только с доски.',
      description: 'Если хотите удалить задачу из плана развития, установите галочку ниже.',
      label: {
        roadmap: 'Удалить из плана',
        roadmap360: 'Удалить из плана',
        meetingTask: 'Удалить из встречи',
      },
      tasks: 'Задачи будут удалены только с доски.',
    },
    placeholders: {
      self: {
        noRoadmaps:
          'У вас ещё нет планов развития для добавления задач на доску. Дождитесь, пока будет организована оценка со стороны организаторов и будут сформированы планы развития.',
        noTasks:
          'У вас нет задач на доске, но вы можете нажать на кнопку «Добавить задачу», чтобы создать их самостоятельно и продолжить процесс развития.',
      },
      notSelf: {
        noRoadmaps:
          'У данного сотрудника ещё нет планов развития для добавления задач на доску. Проведите оценку и будут сформированы планы развития.',
        noTasks:
          'Нет задач на доске, но вы можете нажать на кнопку «Добавить задачу», чтобы создать их.',
      },
    },
    tags: {
      roadmap: 'СМК',
      roadmap360: 'Оценка 360',
      manualTask: 'Задача добавлена вручную',
      meetingTask: '1-on-1',
    },
    newTask: 'Новая задача',
    defaultTypeName: 'Сайт/полезный ресурс',
    noSelectedPlans: 'Отсутствуют выбранные планы',
    commonProgress: 'Общий прогресс',
    step: 'шаг',
    noDeadline: 'отсутствует',
    adaptationPlan: 'План адаптации',
    planDeadline: 'Дедлайн плана',
    materials: 'Материал для изучения',
  },
};
